import { APPLICATION_TYPES_CONST, APPLICATION_STATUS_CONST } from './constants';
import type { Application } from '@/types';

/**
 * Belirli application type'a sahip uygulamayı bulur
 */
export const findApplicationByType = (
  applications: Application[],
  applicationType: string
): Application | null => {
  if (!applications || !Array.isArray(applications)) return null;

  return applications.find(app =>
    app.applicationType === applicationType &&
    app.status === APPLICATION_STATUS_CONST.ACTIVE &&
    app.isActive
  ) || null;
};

/**
 * Carbon Accounting uygulamasının external ID'sini alır
 */
export const getCarbonAccountingCompanyId = (applications: Application[]): string | null => {
  const carbonApp = findApplicationByType(applications, APPLICATION_TYPES_CONST.CARBON_ACCOUNTING);
  return carbonApp ? carbonApp.externalId : null;
};
